import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { Folder } from 'modules/documents/hooks/useGetFolders'
import { ALL_TYPES } from 'modules/documents/lib/constants'

import InformationLink from './InformationLink'

interface Props {
  employeeId: string
  companyId: string
  legalEntityId: string
  folders: Folder[]
}

const Hiring = ({ employeeId, companyId, legalEntityId, folders }: Props) => {
  const { navigation } = useNavigation()

  const payslipFolders = folders.filter((folder) => folder.url == ALL_TYPES['payslip'])
  const payslipFolderId = payslipFolders[0]?.id

  return (
    <>
      <InformationLink
        href={`${navigation.employees.id.personal.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_profile')}
      />
      <InformationLink
        href={`${navigation.employees.id.documents.folderId.fullPath({
          id: employeeId,
          folderId: String(payslipFolderId),
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_payslip_documents')}
      />
      <InformationLink
        href={`${navigation.employees.id.contractVersions.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_contract')}
      />
      <InformationLink
        href={`${navigation.settings.legalEntitiesId.fullPath({
          id: legalEntityId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_legal_entity')}
      />
    </>
  )
}

export default Hiring
